import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FnCoreModule } from '../../core/index';

import { FnTimePickerComponent } from './time-picker/fn-time-picker.component';
import { FnMultiTimePickerComponent } from './multi-time-picker/fn-multi-time-picker.component';
import { FnDurationTimePickerComponent } from './fn-duration-time-picker/fn-duration-time-picker.component';
import { FnTimepickerService } from './services/timepicker.service';
import { FnTranslateModule } from '../../i18n/index';
import { FnTimePicker2Component } from './time-picker/fn-time-picker2';

export * from './time-picker/fn-time-picker.component';
export * from './time-picker/fn-time-picker2';
export * from './fn-duration-time-picker/fn-duration-time-picker.component';
export * from './multi-time-picker/fn-multi-time-picker.component';
export * from './services/timepicker.service';
export * from './services/timepicker.model';

@NgModule({
	imports: [FnCoreModule.forRoot(), CommonModule, FormsModule,FnTranslateModule],
	declarations: [
		FnTimePickerComponent,
		FnTimePicker2Component,
		FnMultiTimePickerComponent,
		FnDurationTimePickerComponent,
	],
	providers: [FnTimepickerService],
	exports: [FnTimePickerComponent, FnTimePicker2Component, FnMultiTimePickerComponent, FnDurationTimePickerComponent],
	schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class FnTimePickerModule {
	static forRoot(): ModuleWithProviders<FnTimePickerModule> {
		return {
			ngModule: FnTimePickerModule,
			providers: [FnTimepickerService],
		};
	}
}
